import React from 'react';
import Head from 'next/head';
import App from 'next/app';
import { baseUrlOf, sanitizeCanonical } from '../src/lib/ssr';

import 'normalize.css';
import '../src/components/css/styles.css';
import MatomoAsyncProvider from '../src/components/common/services/MatomoProvider';
import dynamic from 'next/dynamic';

const TrackPageView = dynamic(
  import('../src/components/common/services/MatomoProvider').then(
    mod => mod.TrackPageView
  ),
  { ssr: false }
);
import uuid from 'uuid';

class MyApp extends App {
  static async getInitialProps({ Component, ctx, router }) {
    const canonical = sanitizeCanonical(
      baseUrlOf(ctx.req),
      router.asPath,
      router.query,
      []
    );

    const pageProps = Component.getInitialProps
      ? await Component.getInitialProps({ canonical, ...ctx })
      : {};
    return { pageProps, canonical };
  }
  render() {
    const href =
      typeof window === 'undefined' ? uuid.v1() : window.location.toString();
    const { Component, pageProps, canonical } = this.props;

    return (
      <>
        <Head>
          <meta
            key="og:image"
            property="og:image"
            content="https://www.yupwego.com/static/images/maldives-960.jpg"
          />
          <meta
            key="twitter:image"
            name="twitter:image"
            content="https://www.yupwego.com/static/images/maldives-960.jpg"
          />
          <meta key="og:locale" property="og:locale" content="FR_fr" />
          <meta key="og:site_name" property="og:site_name" content="YUPWEGO" />
          <meta key="twitter:card" name="twitter:card" content="summary" />
          <meta
            key="fb:app_id"
            property="fb:app_id"
            content="599798923818468"
          />
          <link rel="canonical" href={canonical} key="canonical" />
        </Head>
        <MatomoAsyncProvider
          url={process.env.MATOMO_URL}
          siteId={process.env.MATOMO_SITE_ID}
        >
          <Component {...pageProps} />
          <TrackPageView key={href} />
        </MatomoAsyncProvider>
      </>
    );
  }
}

export default MyApp;
